import { RemarksDTO } from './RemarksDTO';

export class RemarkDataDTO {
  constructor(public data: RemarksDTO) {}
}
